module.exports = __webpack_public_path__ + "static/day16-58788fb08fe48362c5841b77f663c59d.png";